import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/Hero";
import Products from "../components/Products";
import Services from "../components/Services";
import Methodology from "../components/Methodology";
import About from "../components/About";
import BlogPreview from "../components/BlogPreview";
import Contact from "../components/Contact";
import { useSeo } from "../hooks/useSeo";
import { useI18n } from "../i18n/i18n";

export default function Home() {
  const location = useLocation();
  const { lang } = useI18n();

  useSeo({
    title:
      lang === "de"
        ? "Microsoft Azure Cloud Consulting"
        : "Microsoft Azure Cloud Consulting",
    description:
      lang === "de"
        ? "Cloudship unterstützt Unternehmen beim Design, der Governance und der Automatisierung ihrer Microsoft-Azure-Plattform. Enterprise-Scale Landing Zones, CAF, Well-Architected Reviews und ein Terraform Delivery Framework — geliefert von Senior-Azure-Architekten aus Deutschland."
        : "Cloudship helps organisations design, govern and automate their Microsoft Azure platform. Enterprise-Scale Landing Zones, CAF, Well-Architected reviews and a Terraform delivery framework, delivered by senior Azure architects in Germany.",
    path: "/",
    lang,
  });

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Defer so the section is mounted
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [location]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Products />
      <Services />
      <Methodology />
      <About />
      <BlogPreview />
      <Contact />
    </main>
  );
}
